/**
 * @flow
 * @relayHash dfa8fcec022209c5208776902315b155
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailInvoiceInput = {|
  invoiceId: string
|};
export type EmailInvoiceMutationVariables = {|
  input: EmailInvoiceInput
|};
export type EmailInvoiceMutationResponse = {|
  +emailInvoice: {|
    +success: boolean,
    +invoiceStatus: ?string,
  |}
|};
export type EmailInvoiceMutation = {|
  variables: EmailInvoiceMutationVariables,
  response: EmailInvoiceMutationResponse,
|};
*/


/*
mutation EmailInvoiceMutation(
  $input: EmailInvoiceInput!
) {
  emailInvoice(input: $input) {
    success
    invoiceStatus
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailInvoiceInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailInvoice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailInvoicePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "invoiceStatus",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailInvoiceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailInvoiceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailInvoiceMutation",
    "id": null,
    "text": "mutation EmailInvoiceMutation(\n  $input: EmailInvoiceInput!\n) {\n  emailInvoice(input: $input) {\n    success\n    invoiceStatus\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '61e41dd3787fe57ab87ad8dd152ad385';
module.exports = node;
